<template>
  <div class="wrapper-soumissions">
    <b-container fluid>
      <b-row v-if="listeSoumissions.length">
        <b-col cols="3" v-for="soumission in listeSoumissions" :key="soumission.id">
          <b-card
            title
            :img-src="soumission.image"
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2"
          >
            <b-card-text>
              <p class="mb-0"><small>Plan #{{ soumission.id }}</small></p>
              <p>{{ soumission.plan_title }}&nbsp;</p>
              / Modifié le: {{ soumission.date_modified_formated }}
              <br />
              / Status: {{ soumission.status_display }}
            </b-card-text>

            <router-link
              v-if="IsSubmited(soumission)"
              :to="{ name: 'EditSoumission', params: { sid: soumission.ident }}"
            >
              <button class="btn viewBtn" title="Modifier">
                <font-awesome-icon icon="edit" />
              </button>
            </router-link>
            <router-link :to="{ name: 'ViewSoumission', params: { sid: soumission.ident }}">
              <button class="btn viewBtn" title="Voir">
                <font-awesome-icon icon="eye" />
              </button>
            </router-link>

            <button class="btn viewBtn" title="Dupliquer" @click="CopySoumission(soumission.ident)">
              <font-awesome-icon icon="clone" />
            </button>
            <button
                v-if="IsSubmited(soumission)"
              class="btn viewBtn"
              title="Supprimer"
              @click="DeleteSoumission(soumission.ident)"
            >
              <font-awesome-icon icon="times" />
            </button>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col cols="12">
          Aucun plan pour l'instant.
          <router-link :to="{ name: 'CreatePlan'}">Créer un nouveau plan</router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Soumissions",
  data() {
    return {
      listeSoumissions: []
    };
  },
  methods: {
    LoadData: function() {
      this.$http
        .get(this.$url_name + "/submission/", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + localStorage.getItem("token")
          }
        })
        .then(response => {
          this.listeSoumissions = response.body;
        })
        .catch(err => {
          console.log(err);
        });
    },
    CopySoumission: function(soumission_ident) {
      this.$bvModal
        .msgBoxConfirm("Voulez-vous vraiment copier cette soumission?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
        .then(value => {
          console.log(value);
          if (value) {
            if (localStorage.getItem("token")) {
              var dheader = {
                "Content-Type": "application/json",
                Authorization: "Token " + localStorage.getItem("token")
              };
            } else {
              var dheader = { "Content-Type": "application/json" };
            }

            this.$http
              .post(
                this.$url_name + "/submission/" + soumission_ident + "/copy/",
                {
                  headers: dheader
                }
              )
              .then(response => {
                this.$toasted.show("Votre soumission a bien été copié!", {
                  duration: 2000
                });
                this.LoadData();
              })
              .catch(err => {
                console.log(err);
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    DeleteSoumission: function(soumission_ident) {
      this.$bvModal
        .msgBoxConfirm("Voulez-vous vraiment supprimer cette soumission", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
        .then(value => {
          console.log(value);

          if (value) {
            if (localStorage.getItem("token")) {
              var dheader = {
                "Content-Type": "application/json",
                Authorization: "Token " + localStorage.getItem("token")
              };
            } else {
              var dheader = { "Content-Type": "application/json" };
            }

            this.$http
              .delete(
                this.$url_name + "/submission/" + soumission_ident + "/",
                {
                  headers: dheader
                }
              )
              .then(response => {
                this.$toasted.show("Votre soumission a bien été supprimé!", {
                  duration: 2000
                });
                this.LoadData();
              })
              .catch(err => {
                console.log(err);
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    IsSubmited: function(soumission) {
      if (soumission.status == "draft") {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.LoadData();
  }
};
</script>

<style scoped>
.menu-left {
  margin-top: 20px;
  background-color: #dddddd;
  height: 730px;
  padding: 10px;
  font-size: 12px;
}
.wrapper-soumissions {
  margin-top: 20px;
}
.wrapper-soumissions .mb-2 > img {
  width: auto;
  max-width: 96%;
  height: auto;
  max-height: 250px;
  margin: 2% auto;
}
.wrapper-soumissions .mb-2 .card-body {
  padding: 0.5em;
}
.viewBtn {
  margin: 3px 2px;
}
@media (max-width: 1024px) {
  .wrapper-soumissions .col-3 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Soumissions.vue